import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {Service} from "../../../models/service";
import {ServiceControllerService} from "../../../services/service-controller/service-controller.service";

@Component({
  selector: "app-service-select",
  templateUrl: "./service-select.component.html",
  providers: [ServiceControllerService],
})
export class ServiceSelectComponent {

  public services: Service[] = [];
  public userFilter: any = {name: ""};

}
